<template>
  <v-container class=" fill-height mt-1 align-start">
    <v-tabs v-model="tab" @change="onTabChange">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab key="linearList">
        Список
      </v-tab>
      <v-tab key="treeList">
        Структура
      </v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item key="linearList">
          <acceptorsList v-model="selectedContact" :mode="mode"/>
        </v-tab-item>
        <v-tab-item key="treeList">
          <v-row>
            <v-col cols="6" class="">
              <orgTreeView v-model="selectedNode" ref="orgTree" :org="currentOrg"/>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col class=" text-center" cols="5">
              <orgUserCard :user="currentUser" :mode="'view'" @onUserUpdate="doEmployeeChanged"/>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>

<script>
// import { UI_SNACKBAR } from '@/store/actions/ui'
import orgTreeView from '@/components/modules/org/structure/orgTree.vue'
import acceptorsList from '@/components/modules/org/structure/staff/staffList.vue'
import orgUserCard from '@/components/modules/org/structure/staff/userCard.vue'
import { authMixin } from '@/components/modules/mixins/authUtils'

export default {
  components: {
    acceptorsList,
    orgTreeView,
    orgUserCard
  },
  mixins: [authMixin],
  data () {
    return {
      selectedContact: [],
      selectedNode: {},
      tab: 0
    }
  },
  computed: {
    currentUser: {
      get: function () {
        return this.$store.getters.getCurrentUser
      }
    },
    mode: {
      get: function () {
        if (this.userHaveRole('0147896a-9761-45c9-b3e7-39437beb2f4b')) { return 'operator' }
        return 'view'
      }
    },
    currentOrg: {
      get: function () {
        return this.$store.getters.getCurrentOrg
      }
    }
  },
  methods: {
    doEmployeeChanged (data) {
      this.$refs.orgTree.setActive(data)
    },
    onTabChange (tab) {
      console.log('Tab changed to ', tab)
      if (tab === 0) {
        this.$refs.orgTree.setCurrentNode()
      }
    }
  },
  created: function () {
    console.log('Staff list view created (addrbookIndex)')
  }

}
</script>
